import { getConsumptionEstimatesForPreparedMaterials } from "api/GetPredictions";
import { formatStartEndDates } from "lib/Date";
import { QueryStatus, useQuery } from "react-query";
import { IBranchWiseMaterialPrediction } from "types/BranchWiseMaterialPrediction";
import { FMSError } from "types/Error";

interface IQueryPredictionsPreparedMaterial {
  status: QueryStatus;
  branchWiseMaterialPredictionViews: IBranchWiseMaterialPrediction[] | FMSError | undefined;
  isFetching: boolean;
}

export const useQueryPredictionsPreparedMaterial = (
  startDate: Date,
  endDate: Date
): IQueryPredictionsPreparedMaterial => {
  const [start, end] = formatStartEndDates(startDate, endDate, true);
  const {
    status,
    data: branchWiseMaterialPredictionViews,
    isFetching,
  } = useQuery(
    ["predictionsPreparedMaterialV2", start, end],
    async (_: string, start: string, end: string) => {
      return await getConsumptionEstimatesForPreparedMaterials(start, end);
    }
  );
  return { status, branchWiseMaterialPredictionViews, isFetching };
};
